import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import { fetchSales } from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import TaxMaster from "./TaxMaster";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  getRowColData,
  getRowData,
  getTaxNumFromStr,
  getTaxableFromValue,
  isValidItem,
  roundOff,
  setKeyboardShortcuts,
  setTaxPaidRate,
} from "../SystemUtility/SystemUtility";
import ItemMaster from "./ItemMaster";
import SetTaxPaidRate from "./SetTaxPaidRate";

class OCPIttemEntry extends Component {
  state = {
    ItemNameList: [],
    PackingList: [],
    TaxNameList: [],
    StoreNameList: [],
    edit_salessrno: "",
    DefaultStoreName: "",
    formData: {
      cmbStoreName: "",
      txtSrNo: "",
      cmbItemName: "",
      cmbPacking: "",
      txtStock: "",
      txtPurRate: "",
      txtHSN: "",
      txtRate: "",
      txtQty: "",
      txtBasicAmt: "",
      txtDis: "",
      txtDisAmt: "",
      txtTaxable: "",
      cmbTaxName: "",
      txtCGST: "",
      txtSGST: "",
      txtIGST: "",
      txtTotalAmt: "",
      txtRemark: "",
    },
    dataLoadStatus: true,
    ARD: null,
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Item Entry";
    this.props.setActiveMenu("OCPIttemEntry");
    this.ShortCut();
    this.onFormLoad();
  }

  componentWillReceiveProps(newProps) {
    // console.log("newProps",newProps);
    if (
      (newProps.ItemNameList &&
        this.state.ItemNameList &&
        newProps.ItemNameList.length !== this.state.ItemNameList.length) ||
      (newProps.StoreNameList &&
        this.state.StoreNameList &&
        newProps.StoreNameList.length !== this.state.StoreNameList.length)
    ) {
      let ItemNameList = newProps.ItemNameList,
        StoreNameList = newProps.StoreList;
      this.setState({ ItemNameList, StoreNameList });
    }
  }
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name == "cmbItemName" || e.target.name == "cmbPacking") {
          if (e.target.name == "cmbItemName") {
            this.setItemDetail();
            // this.getRate()//Load HSN, Packing, Tax Name
          }
          // this.getPurchaseRate()
        } else if (e.target.name == "txtRate" || e.target.name == "txtQty") {
          this.calBasicAmount();
        } else if (e.target.name == "txtDis") {
          this.calDisAmount();
        } else if (e.target.name == "txtDisAmt") {
          this.getTaxableBasedOnDisAmt();
        } else if (e.target.name == "cmbTaxName") {
          this.calTax_CSGT_SGST_IGST();
        } else if (e.target.name == "txtTotalAmt") {
          this.calcAmtBasedOnTotalAmountInReverse();
        }
      }
    );
  };
  //#endregion handle

  //#region function
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };

  calcAmtBasedOnTotalAmountInReverse = () => {
    let txtTotalAmt = Number(this.state.formData.txtTotalAmt),
      cmbTaxName = this.state.formData.cmbTaxName,
      numTax = getTaxNumFromStr(cmbTaxName),
      txtTaxable = getTaxableFromValue(numTax, txtTotalAmt),
      txtBasicAmt =
        Number(this.state.formData.txtDisAmt) > 0
          ? txtTaxable - Number(this.state.formData.txtDisAmt)
          : txtTaxable,
      txtRate =
        Number(this.state.formData.txtQty) > 0
          ? roundOff(txtBasicAmt / Number(this.state.formData.txtQty), 2)
          : "";

    this.setState({
      formData: {
        ...this.state.formData,
        txtTaxable,
        txtBasicAmt,
        txtRate,
      },
    });
  };

  validateSalesItem = () => {
    let result = false;
    if (
      !isValidItem(
        this.state.StoreNameList,
        "vac_storename",
        this.state.formData.cmbStoreName
      )
    ) {
      this.props.toastErrorMsg("Select Valid Store Name", "cmbStoreName");
    } else if (this.state.formData.cmbItemName.length <= 0) {
      this.props.toastErrorMsg("Select Item Name", "cmbItemName");
    } else if (
      !isValidItem(
        this.state.ItemNameList,
        "vac_itemname",
        this.state.formData.cmbItemName
      )
    ) {
      this.props.toastErrorMsg("Select Valid Item Name", "cmbItemName");
    } else if (this.state.formData.cmbPacking.length <= 0) {
      this.props.toastErrorMsg("Select Packing Name", "cmbPacking");
    } else if (
      !isValidItem(
        this.state.ItemNameList,
        "vac_unit",
        this.state.formData.cmbPacking
      )
    ) {
      this.props.toastErrorMsg("Select Valid Packing Name", "cmbPacking");
    } else if (this.state.formData.txtQty <= 0) {
      this.props.toastErrorMsg("Enter Quantity", "txtQty");
    } else if (this.state.formData.txtRate <= 0) {
      this.props.toastErrorMsg("Enter Rate", "txtRate");
    } /* else if (this.state.formData.txtDis < 0) {
      this.props.toastErrorMsg("Enter Discount (%)", "txtDis");
    } else if (this.state.formData.txtDisAmt < 0) {
      this.props.toastErrorMsg("Enter Discount Amount", "txtDisAmt");
    } */ else if (this.state.formData.cmbTaxName.length <= 0) {
      this.props.toastErrorMsg("Select Tax Name", "cmbTaxName");
    } else if (
      !isValidItem(
        this.state.TaxNameList,
        "vac_taxname",
        this.state.formData.cmbTaxName
      )
    ) {
      this.props.toastErrorMsg("Select Valid Packing Name", "cmbTaxName");
    } else {
      result = true;
    }
    return result;
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      let ItemNameList = [],
        PackingList = [],
        TaxNameList = [],
        StoreNameList = [],
        edit_salessrno = 0;
      if (
        this.props.ItemNameList &&
        this.props.TaxNameList &&
        this.props.StoreList
      ) {
        // console.log("call");
        ItemNameList = this.props.ItemNameList;
        PackingList = this.props.PackingList;
        TaxNameList = this.props.TaxNameList;
        StoreNameList = this.props.StoreList;
        edit_salessrno = this.props.edit_salessrno;
        // console.log("this.props.edit_salessrno", this.props.edit_salessrno);
        this.setState(
          {
            ItemNameList,
            PackingList,
            TaxNameList,
            edit_salessrno,
            dataLoadStatus: true,
            StoreNameList,
          },
          () => {
            this.getDefaultStoreName();
          }
        );
      }
      if (this.props.bint_itemsrno && Number(this.props.bint_itemsrno) > 0) {
        if (
          this.props.EditSalesItemData &&
          this.props.EditSalesItemData.length > 0
        ) {
          let EditSalesItemData = this.props.EditSalesItemData;
          this.setState(
            {
              formData: {
                ...this.state.formData,
                txtSrNo: EditSalesItemData[0].bint_itemsrno,
                cmbItemName: EditSalesItemData[0].vac_itemname,
                cmbStoreName: EditSalesItemData[0].vac_storename,
                cmbPacking: EditSalesItemData[0].vac_unit,
                // txtStock: EditSalesItemData[0].,
                // txtPurRate: EditSalesItemData[0].,
                txtHSN: EditSalesItemData[0].vac_hsncode,
                txtRate: EditSalesItemData[0].dec_rate,
                txtQty: EditSalesItemData[0].dec_qty,
                txtBasicAmt: EditSalesItemData[0].dec_basicamt,
                txtDis: EditSalesItemData[0].dec_disper,
                txtDisAmt: EditSalesItemData[0].dec_disamt,
                txtTaxable: EditSalesItemData[0].dec_taxable,
                cmbTaxName: EditSalesItemData[0].vac_taxname,
                txtCGST: EditSalesItemData[0].dec_cgstamt,
                txtSGST: EditSalesItemData[0].dec_sgstamt,
                txtIGST: EditSalesItemData[0].dec_igstamt,
                txtTotalAmt: EditSalesItemData[0].dec_totalamt,
                txtRemark: EditSalesItemData[0].vac_remark,
              },
            },
            () => {
              document.getElementById("cmbItemName").focus();
            }
          );
        }
      }
    });
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtSrNo: "",
          cmbItemName: "",
          cmbPacking: "",
          txtStock: "",
          txtPurRate: "",
          txtHSN: "",
          txtRate: "",
          txtQty: "",
          txtBasicAmt: "",
          txtDis: "",
          txtDisAmt: "",
          txtTaxable: "",
          cmbTaxName: "",
          txtCGST: "",
          txtSGST: "",
          txtIGST: "",
          txtTotalAmt: "",
          txtRemark: "",
        },
      },
      () => {
        document.getElementById("cmbItemName").focus();
      }
    );
  };

  saveSalesItem = () => {
    if (this.props.userPrivilege.Sales != "R") {
      if (this.validateSalesItem()) {
        const dataLoadStatus = false;
        this.props.notifyProcessing();
        this.setState({ dataLoadStatus }, () => {
          const reqData = {
            Op: "SaveSales_Item",
            bint_ci: localStorage.getItem("CI"),
            vac_username: localStorage.getItem("UserName"),
            bint_acyear: this.props.bint_acyear,
            bolinvoiceprint: false,
            bint_acid: this.props.bint_acid,
            vac_company: this.props.cmbCompany,
            bint_salessrno: this.state.edit_salessrno,
            // bint_salessrno: this.props.edit_salessrno,
            dat_salesdate: this.props.dtpDate,
            vac_billtype: this.props.cmbBillType,
            vac_billno: this.props.txtBillNo,
            bint_billno: this.props.bint_billno,
            vac_customer: this.props.cmbCustomer,
            vac_customershipto: this.props.cmbShipTo,
            vac_referencename: this.props.cmbReference,
            dec_discamt: this.props.txtDiscount,
            dec_taxable: this.props.txtTaxable,
            dec_cgst: this.props.txtCGST,
            dec_sgst: this.props.txtSGST,
            dec_igst: this.props.txtIGST,
            dec_grtotal: this.props.txtGrandTotal,
            dec_tdsamount: this.props.txtTDSAmount,
            dec_advancepayment: this.props.txtAdvPayment,
            dec_roundoff: this.props.txtRoundOff,
            dec_netpayment: this.props.txtNetPayment,
            vac_salestransactiontype: this.props.cmbTransactionType,
            bint_vouno: 0,
            vac_remark: this.state.formData.txtRemark,
            dec_beforetaxamt: this.props.dec_beforetaxamt,
            dec_aftertaxamt: this.props.dec_aftertaxamt,
            SalesItemData: [
              {
                bint_acid: this.props.bint_acid,
                vac_company: this.state.formData.cmbCompany,
                vac_storename: this.state.formData.cmbStoreName,
                bint_itemsrno: this.state.formData.txtSrNo,
                bint_salessrno: this.state.formData.edit_salessrno,
                vac_itemname: this.state.formData.cmbItemName,
                vac_hsncode: this.state.formData.txtHSN,
                vac_unit: this.state.formData.cmbPacking,
                dec_qty: this.state.formData.txtQty,
                dec_rate: this.state.formData.txtRate,
                dec_basicamt: this.state.formData.txtBasicAmt,
                dec_disper: this.state.formData.txtDis,
                dec_disamt: this.state.formData.txtDisAmt,
                dec_taxable: this.state.formData.txtTaxable,
                vac_taxname: this.state.formData.cmbTaxName,
                dec_cgstamt: this.state.formData.txtCGST,
                dec_sgstamt: this.state.formData.txtSGST,
                dec_igstamt: this.state.formData.txtIGST,
                dec_totalamt: this.state.formData.txtTotalAmt,
                vac_remark: this.state.formData.txtRemark,
              },
            ],
            PaymentData:
              this.props.cmbTransactionType == "Paid"
                ? this.props.rowsPaymentMode
                : [],
            OtherDetailData: this.props.rowsOtherDetail,
          };
          fetchSales(reqData)
            .then((res) => {
              this.props.updateProcessing(res.data.msgType, res.data.message);
              if (res.data.msgType === "success") {
                let dec_basicamt = 0,
                  dec_disamt = 0,
                  dec_taxable = 0,
                  dec_cgstamt = 0,
                  dec_sgstamt = 0,
                  dec_igstamt = 0,
                  dec_totalamt = 0,
                  SalesItemData = [],
                  bint_salessrno = 0;
                // this.props.onSuccessfulSalesItemEntry(res.data.SalesItemData);
                if (res.data.SalesItemData) {
                  SalesItemData = res.data.SalesItemData;
                }
                if (res.data.SalesList) {
                  bint_salessrno = res.data.SalesList[0].bint_salessrno;
                  // console.log("bint_salessrno", bint_salessrno);
                  // console.log(
                  //   "res.data.SalesList[0].bint_salessrno",
                  //   res.data.SalesList[0].bint_salessrno
                  // );
                }
                if (res.data.TotalItemAmountData) {
                  dec_basicamt = Number(
                    res.data.TotalItemAmountData[0].dec_basicamt
                  );
                  dec_disamt = Number(
                    res.data.TotalItemAmountData[0].dec_disamt
                  );
                  dec_taxable = Number(
                    res.data.TotalItemAmountData[0].dec_taxable
                  );
                  dec_cgstamt = Number(
                    res.data.TotalItemAmountData[0].dec_cgstamt
                  );
                  dec_sgstamt = Number(
                    res.data.TotalItemAmountData[0].dec_sgstamt
                  );
                  dec_igstamt = Number(
                    res.data.TotalItemAmountData[0].dec_igstamt
                  );
                  dec_totalamt = Number(
                    res.data.TotalItemAmountData[0].dec_totalamt
                  );
                }
                this.setState(
                  {
                    edit_salessrno: bint_salessrno,
                  },
                  () => {
                    this.props.resetAmount(
                      dec_taxable,
                      dec_cgstamt,
                      dec_sgstamt,
                      dec_igstamt,
                      dec_totalamt,
                      dec_disamt,
                      bint_salessrno
                    );
                    this.props.refreshSalesItemList(
                      SalesItemData,
                      SalesItemData.length
                    );
                    this.clearInfo();
                  }
                );
              }
            })
            .catch((error) => {
              console.log("Unknown error occurred in saveSalesItem.", error);
            });
        });
      }
    }
  };

  onDeleteBtnClick = () => {
    if (Number(this.state.formData.txtSrNo) > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Item : " +
              this.state.formData.cmbItemName +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deleteSalesItem(
                this.props.bint_acyear,
                this.props.bint_acid,
                this.props.edit_salessrno,
                this.state.formData.txtSrNo
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("There are no item to delete", "cmbItemName");
    }
  };

  deleteSalesItem = (bint_acyear, bint_acid, bint_salessrno, bint_itemsrno) => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeleteSalesItem",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_salessrno: bint_salessrno,
        edit_itemsrno: bint_itemsrno,
        dec_tdsamount: this.props.txtTDSAmount,
        dec_advancepayment: this.props.txtAdvPayment,
        vac_customer: this.props.cmbCustomer,
        bint_ci: localStorage.getItem("CI"),
        vac_username: localStorage.getItem("UserName"),
        dat_salesdate: this.props.dtpDate,
        vac_remark: this.props.txtRemark,
        vac_salestransactiontype: this.props.cmbTransactionType,
        PaymentData: this.props.rowsPaymentMode,
        dec_roundoff: this.props.txtRoundOff,
        vac_billno: this.props.txtBillNo,
        dec_netpayment: this.props.txtNetPayment,
        vac_receiptgenerated: this.props.chkReceiptGenerated ? "Yes" : "No",
      };
      fetchSales(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          let dec_basicamt = 0,
            dec_disamt = 0,
            dec_taxable = 0,
            dec_cgstamt = 0,
            dec_sgstamt = 0,
            dec_igstamt = 0,
            dec_totalamt = 0,
            SalesItemData = [];
          if (res.data.SalesItemData && res.data.SalesItemData.length > 0) {
            rows = res.data.SalesItemData;
            rowsCount = rows.length;
          }
          if (res.data.TotalItemAmountData) {
            dec_basicamt = Number(res.data.TotalItemAmountData[0].dec_basicamt);
            dec_disamt = Number(res.data.TotalItemAmountData[0].dec_disamt);
            dec_taxable = Number(res.data.TotalItemAmountData[0].dec_taxable);
            dec_cgstamt = Number(res.data.TotalItemAmountData[0].dec_cgstamt);
            dec_sgstamt = Number(res.data.TotalItemAmountData[0].dec_sgstamt);
            dec_igstamt = Number(res.data.TotalItemAmountData[0].dec_igstamt);
            dec_totalamt = Number(res.data.TotalItemAmountData[0].dec_totalamt);
          }
          this.setState(
            {
              ARD: null,
              dataLoadStatus,
            },
            () => {
              this.props.resetAmount(
                dec_taxable,
                dec_cgstamt,
                dec_sgstamt,
                dec_igstamt,
                dec_totalamt,
                dec_disamt,
                bint_salessrno
              );
              this.props.refreshSalesItemList(rows, rowsCount);
              this.clearInfo();
            }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in deleteSalesItem.", error);
        });
    });
  };

  getRate = () => {
    let dataLoadStatus = false,
      txtRate = 0;
    if (
      this.state.formData.cmbItemName != "" &&
      this.state.formData.cmbItemName.length > 0
    ) {
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "GetSalesRate",
          bint_acyear: this.props.bint_acyear,
          bint_acid: this.props.bint_acid,
          vac_itemname: this.state.formData.cmbItemName,
          vac_customer: this.props.cmbCustomer,
          vac_unit: this.state.formData.cmbPacking,
        };
        fetchSales(reqData)
          .then((res) => {
            txtRate = Number(res.data.dec_rate);
            dataLoadStatus = true;
            this.setState({
              dataLoadStatus,
              formData: {
                ...this.state.formData,
                txtRate,
              },
            });
          })
          .catch((error) => {
            console.log("Unknown error occurred in getPurchaseRate.", error);
          });
      });
    } else {
      this.setState({
        dataLoadStatus,
        formData: {
          ...this.state.formData,
          txtRate,
        },
      });
    }
  };

  getPurchaseRate = () => {
    let dataLoadStatus = false,
      txtPurRate = 0;
    if (
      this.state.formData.cmbPacking.length > 0 &&
      this.state.formData.cmbItemName.length > 0
    ) {
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "GetPurchaseRate",
          bint_acyear: this.props.bint_acyear,
          bint_acid: this.props.bint_acid,
          vac_itemname: this.state.formData.cmbItemName,
          vac_unit: this.state.formData.cmbPacking,
        };
        fetchSales(reqData)
          .then((res) => {
            txtPurRate = Number(res.data.dec_purrate);
            dataLoadStatus = true;
            this.setState({
              dataLoadStatus,
              formData: {
                ...this.state.formData,
                txtPurRate,
              },
            });
          })
          .catch((error) => {
            console.log("Unknown error occurred in getPurchaseRate.", error);
          });
      });
    }
  };

  calBasicAmount = () => {
    let txtBasicAmt = 0;
    if (
      Number(this.state.formData.txtRate) > 0 &&
      Number(this.state.formData.txtQty) > 0
    ) {
      txtBasicAmt =
        Number(this.state.formData.txtRate) *
        Number(this.state.formData.txtQty);
    }
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtBasicAmt,
          txtTaxable: txtBasicAmt,
        },
      },
      () => {
        this.calDisAmount();
      }
    );
  };

  getTaxableBasedOnDisAmt = () => {
    let txtTaxable =
      Number(this.state.formData.txtBasicAmt) -
      Number(this.state.formData.txtDisAmt);
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtDis: "",
          txtTaxable,
        },
      },
      () => {
        this.calTax_CSGT_SGST_IGST();
      }
    );
  };

  calDisAmount = () => {
    let txtDisAmt = 0,
      txtTaxable = 0;
    if (Number(this.state.formData.txtDis) > 0) {
      txtDisAmt =
        (Number(this.state.formData.txtBasicAmt) *
          Number(this.state.formData.txtDis)) /
        100;
      txtTaxable = Number(this.state.formData.txtBasicAmt) - txtDisAmt;
      // console.log('txtTaxable from If', txtTaxable)
    } else if (Number(this.state.formData.txtDisAmt) > 0) {
      txtTaxable =
        Number(this.state.formData.txtBasicAmt) -
        Number(this.state.formData.txtDisAmt);
      // console.log('txtTaxable from Else if, txtBasicAmt, txtDisAmt', txtTaxable, this.state.formData.txtBasicAmt, this.state.formData.txtDisAmt)
    } else {
      txtTaxable = Number(this.state.formData.txtBasicAmt);
    }
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtDisAmt,
          txtTaxable,
        },
      },
      () => {
        this.calTax_CSGT_SGST_IGST();
        // this.calTotalAmount()
      }
    );
  };

  calTax_CSGT_SGST_IGST = () => {
    let txtIGST = 0,
      txtSGST = 0,
      txtCGST = 0;
    if (this.state.formData.cmbTaxName.length > 0) {
      const txtTaxable = Number(this.state.formData.txtTaxable),
        cmbTaxName = getTaxNumFromStr(this.state.formData.cmbTaxName);
      //Number(this.state.formData.cmbTaxName.substring(0, this.state.formData.cmbTaxName.length - 1))
      let txtCGST = 0,
        txtSGST = 0,
        txtIGST = 0;
      if (Number(txtTaxable) >= 0 && Number(cmbTaxName) >= 0) {
        txtCGST = (txtTaxable * (cmbTaxName / 2)) / 100;
        txtCGST = txtCGST.toFixed(2);
        txtSGST = txtCGST;
        // console.log("this.props.CustomerStateCode",this.props.CustomerStateCode);
        // console.log("localstorage",localStorage.getItem('CompStateCode'));
        if (
          this.props.CustomerStateCode != localStorage.getItem("CompStateCode")
        ) {
          txtIGST = Number(txtCGST) + Number(txtSGST);
          txtCGST = 0;
          txtSGST = 0;
        }
      }
      this.setState(
        {
          formData: {
            ...this.state.formData,
            txtCGST: Number(txtCGST),
            txtSGST: Number(txtSGST),
            txtIGST: Number(txtIGST),
          },
        },
        () => {
          // console.log("txtCGST", txtCGST);
          // console.log("txtSGST", txtSGST);
          // console.log("txtIGST", txtIGST);
          // console.log("this.state.formData.txtCGST", this.state.formData.txtCGST);
          // console.log("this.state.formData.txtSGST", this.state.formData.txtSGST);
          // console.log("this.state.formData.txtIGST", this.state.formData.txtIGST);
          this.calTotalAmount();
        }
      );
    }
  };

  calTotalAmount = () => {
    let txtTotalAmt = 0;
    if (Number(this.state.formData.txtTaxable) > 0) {
      txtTotalAmt =
        Number(this.state.formData.txtTaxable) +
        Number(this.state.formData.txtSGST) +
        Number(this.state.formData.txtCGST) +
        Number(this.state.formData.txtIGST);
      txtTotalAmt = txtTotalAmt.toFixed(2);
    }
    this.setState({
      formData: {
        ...this.state.formData,
        txtTotalAmt,
      },
    });
  };

  getDefaultStoreName = () => {
    if (this.state.StoreNameList.length > 0) {
      this.state.StoreNameList.map((row) => {
        if (row.int_default == 1 || row.int_default == "1") {
          this.setState(
            {
              DefaultStoreName: row.vac_storename,
              formData: {
                ...this.state.formData,
                cmbStoreName: row.vac_storename,
              },
            },
            () => {
              // console.log("this.state.formData.cmbStoreName", this.state.formData.cmbStoreName);
            }
          );
        }
      });
    }
  };

  setItemDetail = () => {
    if (
      this.state.ItemNameList.length > 0 &&
      this.state.formData.cmbItemName.length > 0
    ) {
      this.state.ItemNameList.map((row) => {
        if (row.vac_itemname == this.state.formData.cmbItemName) {
          this.setState(
            {
              formData: {
                ...this.state.formData,
                cmbPacking: row.vac_unit,
                txtHSN: row.vac_hsncode,
                txtRate: Number(row.dec_salesrate),
                cmbTaxName: row.vac_taxname,
              },
            },
            () => {
              return;
            }
          );
        }
      });
    }
  };

  openTaxMaster = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={
            <TaxMaster refreshTaxNameList={this.refreshTaxNameList} />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  refreshTaxNameList = (TaxNameList) => {
    this.setState({
      TaxNameList,
    });
  };

  // ShortCut = () => {
  //   this.setState({
  //     removeKeyboardShortCuts: setKeyboardShortcuts(
  //       this.saveSalesItem,
  //       this.clearInfo,
  //       () => {
  //         this.onDeleteBtnClick();
  //       }
  //     ),
  //   });
  // };

  onAddClickItem = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<ItemMaster
            OpenFromSalesItem="Yes"
            refreshItemNameList={this.refreshItemNameList}
          />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.props.getItemList();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  refreshItemNameList = (ItemNameList) => {
    this.setState({
      ItemNameList,
    });
  };

  onTpTextChange = (NewTP) => {
    let txtRate = 0;
    if (Number(NewTP) > 0) {
      // console.log("NewTP", NewTP);
      let numTax = getTaxNumFromStr(this.state.formData.cmbTaxName);
      // console.log("numTax", numTax);
      txtRate = setTaxPaidRate(
        numTax,
        NewTP,
        Number(this.state.formData.txtQty)
      );
      // console.log("txtRate", txtRate);
      this.setState(
        {
          formData: {
            ...this.state.formData,
            txtRate,
          },
        },
        () => {
          this.calBasicAmount();
        }
      );
    } else {
      this.setState(
        {
          formData: {
            ...this.state.formData,
            txtRate,
          },
        },
        () => {
          this.calBasicAmount();
        }
      );
    }
  };

  openTaxPaidRateARD = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Set Rate"
          // labelAgree='Set'
          alertMessage={
            <SetTaxPaidRate
              onTpTextChange={this.onTpTextChange}
              closeTaxPaidRateARD={this.closeTaxPaidRateARD}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  closeTaxPaidRateARD = () => {
    let ARD = null;
    this.setState({ ARD });
  };
  //#endregion function

  render() {
    // console.log("this.props.CustomerStateCode", this.props.CustomerStateCode);
    // console.log("this.props.dec_beforetaxamt", this.props.dec_beforetaxamt);
    let bolnumTax =
      getTaxNumFromStr(this.state.formData.cmbTaxName) > 0 ? false : true;
    let { module } = this.props;

    return (
      <form>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>{module + " Item Entry"}</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtNum
              id="txtSrNo"
              label="Sr. No."
              value={this.state.formData.txtSrNo}
              handleOnChange={this.handleOnChange}
              width={50}
              maxLength={10}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbStoreName"
              label="Store Name*"
              value={this.state.formData.cmbStoreName}
              handleOnChange={this.handleOnChange}
              items={this.state.StoreNameList}
              width={150}
              maxLength={100}
              colID="vac_storename"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtCmbEditable
              id="cmbItemName"
              label="Item Name*"
              value={this.state.formData.cmbItemName}
              handleOnChange={this.handleOnChange}
              // items={this.state.ItemNameList}
              items={getRowColData(this.state.ItemNameList, "vac_itemname")}
              width={500}
              maxLength={100}
              colID="vac_itemname"
              bolVisibleOnAddClickIcon={
                this.props.userPrivilege.Item == "A" ? true : false
              }
              onAddClick={this.onAddClickItem}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbPacking"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxt
              id="txtHSN"
              label="HSN"
              value={this.state.formData.txtHSN}
              handleOnChange={this.handleOnChange}
              width={110}
              maxLength={10}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbPacking"
              label="Packing*"
              items={this.state.ItemNameList}
              value={this.state.formData.cmbPacking}
              handleOnChange={this.handleOnChange}
              width={110}
              maxLength={10}
              colID="vac_unit"
              dataFilter={[
                {
                  filterColID: "vac_itemname",
                  value: this.state.formData.cmbItemName,
                },
              ]}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtQty"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtQty"
              label="Quantity*"
              value={this.state.formData.txtQty}
              handleOnChange={this.handleOnChange}
              width={110}
              maxLength={15}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtRate"
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="Set TP Rate"
              onClick={this.openTaxPaidRateARD}
              disabled={bolnumTax}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtRate"
              label="Rate*"
              value={this.state.formData.txtRate}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={15}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtDis"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtBasicAmt"
              label="Basic Amt"
              value={this.state.formData.txtBasicAmt}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtDis"
              label="Dis (%)"
              value={this.state.formData.txtDis}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={15}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtDisAmt"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtDisAmt"
              label="Dis Amt"
              value={this.state.formData.txtDisAmt}
              handleOnChange={this.handleOnChange}
              width={120}
              maxLength={15}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbTaxName"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtTaxable"
              label="Taxable"
              value={this.state.formData.txtTaxable}
              handleOnChange={this.handleOnChange}
              width={120}
              maxLength={10}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbTaxName"
              label="Tax Name*"
              items={this.state.TaxNameList}
              value={this.state.formData.cmbTaxName}
              handleOnChange={this.handleOnChange}
              width={150}
              maxLength={20}
              colID="vac_taxname"
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtTotalAmt"
            />
          </Grid>
          {/* <Grid item>
            <CtBtn label={<Add />} onClick={this.openTaxMaster} />
          </Grid> */}
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtCGST"
              label="CGST"
              value={this.state.formData.txtCGST}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtSGST"
              label="SGST"
              value={this.state.formData.txtSGST}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtIGST"
              label="IGST"
              value={this.state.formData.txtIGST}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              disabled={true}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtTotalAmt"
              label="Total Amount"
              value={this.state.formData.txtTotalAmt}
              handleOnChange={this.handleOnChange}
              width={160}
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtMultiLineText
              id="txtRemark"
              label="Remark"
              value={this.state.formData.txtRemark}
              handleOnChange={this.handleOnChange}
              width={340}
              maxLength={500}
              defaultAction={this.saveSalesItem}
              validateInput={this.validateSalesItem}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid
            item
            display={this.props.userPrivilege.Sales == "R" ? "none" : "block"}
          >
            <CtBtn label="Add" onClick={this.saveSalesItem} />
          </Grid>
          <Grid item>
            <CtBtn label="New" onClick={this.clearInfo} />
          </Grid>
          <Grid
            item
            display={this.props.userPrivilege.Sales !== "M" ? "none" : "block"}
          >
            <CtBtn label="Remove" onClick={this.onDeleteBtnClick} />
          </Grid>
        </Grid>
        <br />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HoCtToastContainer(OCPIttemEntry));
